<div
  *ngIf="props$ | async as props"
  class="large-event-card d-flex flex-column h-100"
  floElementIsVisible
  (elementIsVisible)="elementInView$.next($event)"
  data-test="large-event-card"
>
  <a
    floAnalytics
    [analyticsProperties]="props.analyticsProps"
    tagName="List Item"
    elementName="Large Event Card"
    data-test="large-event-card-image"
    class="large-event-card-image image w-100 h-auto cursor-pointer"
    [routerLink]="props.destination"
  >
    <div *ngIf="props.showTopBadge" class="large-event-card-image__badges-top position-absolute z-index-min ms-2">
      <flo-svg-icon data-test="badge-live" icon="badge-live" width="1em" class="badge-live color-100 svg-vertical-align-middle"></flo-svg-icon>
    </div>
    <ng-container *ngIf="isLivePreviewStreamAvailable$ | async as livePreview; else imageThumbnail">
      <flo-video-preview
        data-test="video-preview"
        class="d-flex flex-column"
        [src]="livePreview.cleanUri" [posterImage]="props.imageThumbnailProps.imageUrl" (videoError)="handleVideoError$.next($event)"></flo-video-preview>
    </ng-container>
    <ng-template #imageThumbnail>
      <flo-image-thumbnail
        data-test="image-thumbnail"
        [imageUrl]="props.imageThumbnailProps.imageUrl"
        [imageSize]="props.imageThumbnailProps.imageSize"
        [altText]="props.imageThumbnailProps.altText"
        [duration]="props.imageThumbnailProps.duration"
        [mobileSize]="props.imageThumbnailProps.mobileSize"
      >
        <div class="large-event-card-image__badges-bottom d-flex flex-row w-100">
          <div *ngIf="props.badgeText !== null" class="img-overlay-badge caption me-1" data-test="badge-text">{{ props.badgeText }}</div>
          <ng-container *ngIf="props.liveEventId !== null && !!geoBlockedIds">
            <div *ngIf="geoBlockedIds.includes(props.liveEventId)" class="img-overlay-badge geo-icon">
              <flo-svg-icon icon="geoblocked-filled" width="1em" class="svg-vertical-align-middle caption" data-test="geo-block"></flo-svg-icon>
            </div>
          </ng-container>
        </div>
      </flo-image-thumbnail>
    </ng-template>
  </a>
  <div class="large-event-card-text d-flex flex-column align-content-between">
    <div class="large-event-card-text__details">
      <a
        *ngIf="props.drillThroughLink !== null"
        floAnalytics
        elementName="Drill Through Link"
        class="large-event-card-text__details--drill-through drill-through"
        [routerLink]="props.drillThroughLink?.slug_uri"
      >
        {{ props.drillThroughLink?.short_name || props.drillThroughLink?.name }}
      </a>
      <a
        floAnalytics
        [analyticsProperties]="props.analyticsProps"
        tagName="List Item"
        elementName="Large Event Card"
        class="large-event-card-text__details--title d-block mb-0 cursor-pointer"
        [routerLink]="props.destination" data-test="title"
      >
        <h3 class="large-event-card-text__details--title font-family-heavy h3 text-line-clamp-2 primary-color-hover">{{ props.displayTitle }}</h3>
      </a>
      <div *ngIf="props.eventStatusProps !== null" class="large-event-card-text__details--status-date footnote" data-test="event-status">
        <flo-event-status [props]="props.eventStatusProps"></flo-event-status>
      </div>
    </div>
    <ul *ngIf="props.tags.length > 0" class="large-event-card-text__tags d-flex flex-row flex-wrap align-items-center mb-1">
      <li *ngFor="let tag of props.tags" class="pe-2" data-test="tag">
        <flo-tag [tag]="tag" [collectionTabUriPart]="'/'"></flo-tag>
      </li>
    </ul>
  </div>
</div>
